<div class="dropzone" appDragAndDrop (fileDropped)="onFileDropped($event)">
  <div class="row files">
    <div *ngFor="let file of files; let i = index" class="col-lg-6 col-sm-12 mb-3">
      <div class="file-item">
        <div class="file-info-container">
          <img
            style="max-height: 46px; max-width: 46px; margin-right: 8px"
            [src]="displayImageOrFileIcon(file)"
            alt=""
          />
          <button class="file-info-btn" (click)="downloadFile(file)">
            <b>{{ file.name ? file.name : getFilenameFromUrl(file) }}</b>
            <br />
            Size: {{ file.size ? formatBytes(file.size) : "" }}
          </button>
        </div>
        <button
          *ngIf="
            router.url.includes('management') || router.url.includes('order')
          "
          class="btn ms-2"
          (click)="deleteFile(i, file)"
        >
          <img src="assets/trash.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
  <img
    *ngIf="files.length == 0"
    class="cloud"
    src="assets/upload-cloud.svg"
    alt=""
  />
  <div *ngIf="files.length == 0" class="load-field-label">
    Перенесите файл в размеченную область, или
  </div>
  <input
    type="file"
    #fileDropRef
    id="fileDropRef"
    multiple
    (change)="fileBrowseHandler($event)"
  />
  <label for="fileDropRef" class="select-file-button">Загрузите файлы</label>
</div>
